module.exports = __webpack_public_path__ + "static/media/menu-x-mob.a1406cbb.svg";